import { NAME_ADDRESS_LOGIN_INITIATE } from '@src/app/login/weak/nameaddress/actions';
import { ActionsObservable, StateObservable, ofType } from 'redux-observable';
import { RootAction, RootState } from '@src/app/_redux';
import { actionCreators as weakActionCreators } from '@src/app/login/weak/actions';
import { AccountLookupTypes } from '@src/app/_global/domain/AccountLookupTypes';
import { WsgRequest } from '@src/app/_global/domain/WsgRequest';
import { mergeMap, delay } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { countriesWithNoPostalCodes } from '@src/app/_global/constants';

export const nameAddressLoginInitiate = (
  action$: ActionsObservable<RootAction>,
  state$: StateObservable<RootState>,
) =>
  action$.pipe(
    ofType(NAME_ADDRESS_LOGIN_INITIATE),
    mergeMap(({ payload }) => {
      var clientConfig = state$.value.clientConfig.clientConfig;
      const adminConfig = state$.value.adminConfig.adminConfig;

      let defaultMagClientProperty;
      let tableName = 'ClientProperties';
      if (adminConfig[clientConfig.magCode]) {
        defaultMagClientProperty = adminConfig[clientConfig.magCode][tableName];
      }

      // find default postal code value for countries that don't have any.
      const country = countriesWithNoPostalCodes.find(item => item.value === payload.country);
      const postalCode = payload.postalCode || (country ? country.postalCode : '');

      var wsgPayload: WsgRequest = {
        magCode: clientConfig.magCode,
        globalCode: clientConfig.globalCode,
        filterType: AccountLookupTypes.nameAddress,
        payload: {
          name: (payload.firstName + ' ' + payload.lastName) as string,
          firstName: payload.firstName as string,
          lastName: payload.lastName as string,
          address1: payload.address1 as string,
          address2: payload.address2 as string,
          city: payload.city as string,
          state: payload.state as string,
          postalCode: postalCode as string,
          country: payload.country as string,
          email: payload.captureEmail as string,
          emailOptIn: payload.emailOptIn as string,
          productExcludes: payload.productExcludes.toString(),
        },
        systemCode: defaultMagClientProperty.ProductType,
      };
      var credentials = state$.value.auth.omsAuth.credentials;
      let observable;
      if (credentials && credentials.Logins) {
        wsgPayload.idpAccountInfo = state$.value.userState.idpAccountInfo;
        observable = of(
          weakActionCreators.authIamKeysSuccess(credentials, wsgPayload),
        );
      } else {
        observable = of(weakActionCreators.unauthGetIamKeys(wsgPayload));
      }
      return observable;
    }),
  );
